module.exports = __webpack_public_path__ + "static/media/multidashboard.55437560.svg";